import { displayNotification, sendAPIRequest } from "helpers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useCreateMissionCorrespondenceCCMutation,
  useGetMissionCorrespondenceCCQuery,
} from "modules/pvs_activities/redux/service/missions";
import MissionActorsComponent from "./mission_configuration/MissionActorsComponent";
import MissionCCsComponent from "./mission_configuration/MissionCCsComponent";

const MissionCC = ({ missionID, canChangeMissionActors, refresh }) => {
  const { t } = useTranslation();
  const { data, error, isLoading } = useGetMissionCorrespondenceCCQuery({ missionID }, { skip: missionID === "" });
  const [createMissionCorrespondenceCC, { isLoading: correspondenceLoading }] =
    useCreateMissionCorrespondenceCCMutation();

  const [tableData, setTableData] = useState([]);
  const [actorTableData, setActorTableData] = useState([]);
  const [CCDataTable, setCCDataTable] = useState([]);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (missionID) {
      getActorData();
      getCCData();
    }
  }, [data, refresh]);


  const getActorData = async () => {
    await getMissionActors();
  }
  const getCCData = async () => {
    await getMissionCC();
  }
  //--//
  const getMissionActors = async () => {
    try {
      const ret = await sendAPIRequest(`/api/pvsa/mission-correspondence-cc/mission-actors/${missionID}?role_status=actor`);
      const res = await ret.json();
      if (res.success && res.status === 200) {
        setActorTableData(res?.data);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const getMissionCC = async () => {
    try {
      const ret = await sendAPIRequest(`/api/pvsa/mission-correspondence-cc/mission-actors/${missionID}?role_status=cc`);
      const res = await ret.json();
      if (res.success && res.status === 200) {
        setCCDataTable(res?.data);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const handleAddClick = (actor, value) => {
    handleActorSave(actor, value);
  };

  const handleMissionCCAddClick = (actor, value) => {
    updateMissionCC(actor, value);
  }


  const handleAddAll = (actors = []) => {
    const temp = [];
    tableData.forEach(d => {
      actors.forEach(actor => {
        if (d.mission_actor_type === actor.value) {
          temp.push({
            role_id: actor.value,
            user_id: actor.value,
            role_name: actor.label,
            user_name: actor.label,
            mission_actor_type: d.mission_actor_type,
            mission_actor_name: d.mission_actor_name,
            is_letter_cc: actor.currentIsLetterCC,
          });
        }
      });
    });
    setTableData(temp);
  }

  const handleDeleteClick = async(actor) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return handleActorUnassign(actor);
  }

  const handleActorSave = async (actor) => {
    if (!actor.user_id) {
      getActorData();
      displayNotification("warning", "User is not updated for this mission actor.");
    }else{
        try {
          const response = await sendAPIRequest(
            `/api/pvsa/mission-correspondence-cc/assign-user/${actor.id}`, // Endpoint to assign the user
            "PUT",
            {
              user_id: actor.user_id,
            }
          );

          const result = await response.json();

          if (result && result.success) {
            // Update the local state to reflect the changes
            // const updatedActors = actorTableData.map((existingActor) =>
            //   existingActor.id === actor.id
            //     ? { ...existingActor, user_id: actor.user_id } // Update the user_id for the specific actor
            //     : existingActor
            // );

            // setActorTableData(updatedActors); // Update the state with the new data
            setTimeout(() => { getActorData(); getCCData(); }, 1000);
            displayNotification("success", "User successfully assigned to mission actor");
          } else {
            displayNotification("error", "Error assigning user to mission actor");
          }
        } catch (error) {
          console.error("Error in handleActorSave:", error);
          displayNotification("error", "An error occurred while assigning the user");
        }
    }
  };

  const handleActorUnassign = async (actor) => {
    if (!actor.user_id) {
      displayNotification("warning", "User is not assigned for this mission actor.");
    }else{
      try {
        // Make the PUT request to unassign the user
        const response = await sendAPIRequest(
          `/api/pvsa/mission-correspondence-cc/unassign-user/${actor.id}`, // Endpoint to unassign the user
          "PUT",
          {
            mission_id: actor.mission_id, // Include mission_id if required by the backend
            user_id: null, // Send null to unassign the user
          }
        );

        const result = await response.json();

        if (result && result.success) {
          // Update the local state to reflect the changes
          const updatedActors = actorTableData.map((existingActor) =>
            existingActor.id === actor.id
              ? { ...existingActor, user_id: null,relationUser:{} } // Remove the user_id for the specific actor
              : existingActor
          );

          setActorTableData(updatedActors); // Update the state with the new data
          deleteMissionCC(actor);
          setTimeout(() => { getCCData(); }, 1000);

          displayNotification("success", "User successfully unassigned from mission actor");
        } else {
          displayNotification("error", "Error unassigning user from mission actor");
        }
      } catch (error) {
        console.error("Error in handleActorUnassign:", error);
        displayNotification("error", "An error occurred while unassigning the user");
      }
    }
  };

  //----///
  // const handleSave = (tempData = []) => {
  //   const formData = new FormData();
  //   formData.append("mission_id", missionID);
  //   const transformedData = tempData.map((item) => ({
  //     role_id: item.role_id,
  //     user_id: item.user_id,
  //     mission_actor_type: item.mission_actor_type,
  //     is_letter_cc: item.is_letter_cc,
  //   }));
  //   formData.append("cc_data", JSON.stringify(transformedData));

  //   createMissionCorrespondenceCC(formData).then((response) => {
  //     if (response.error) {
  //       displayNotification("error", response.error);
  //     } else {
  //       displayNotification("success", "Successfully Data Saved");
  //     }
  //   });
  // };


  // later will remove
  const handleUpdate = (actor, value, key) => {
    const temp = [];
    if (key !== "letter_cc") {
      actorTableData.forEach(d => {
        if (d.mission_actor_type === actor.mission_actor_type) {
          temp.push({
            ...actor,
            ...(
              key === "user"
                ? {
                  user_id: value.value,
                  user_name: value.label,
                }
                : {
                  role_id: value.value,
                  role_name: value.label,
                }
            )
          })
        } else {
          temp.push(d);
        }
      });
    }
    if (key === "letter_cc") {
      actorTableData.forEach(d => {
        if (d.mission_actor_type === actor.mission_actor_type) {
          temp.push({
            ...actor,
            is_letter_cc: value,
          })
        } else {
          temp.push(d);
        }
      });
    }
    setActorTableData(temp);
  }

  const updateMissionCCState = (updatedActor, value) => {
    const updatedCCTableData = CCDataTable.map((actor) =>
      actor.id === updatedActor.id
        ? { ...actor, is_letter_cc: value } // Update the specific actor
        : actor // Keep the rest unchanged
    );
    setCCDataTable(updatedCCTableData);
  }


  const updateMissionCC = async (updatedActor) => {
    if (!updatedActor.user_id) {
      displayNotification("warning", "Mission Actor is not assigned.");
    }else{
      try {
        const response = await sendAPIRequest(
          `/api/pvsa/mission-correspondence-cc/assign-letter-cc/${updatedActor.id}`,
          "PUT",
          {
            mission_id: updatedActor.mission_id,
            is_letter_cc: updatedActor?.is_letter_cc, // Send the updated value
          }
        );

        const result = await response.json();
        if (result && result.success) {
          // Update local state upon successful backend update
          const updatedCCTableData = CCDataTable.map((actor) =>
            actor.id === updatedActor.id
              ? { ...actor, is_letter_cc: updatedActor?.is_letter_cc } // Update the specific actor
              : actor // Keep the rest unchanged
          );
          setCCDataTable(updatedCCTableData);

          displayNotification('success', 'Successfully updated Mission CC');
        } else {
          displayNotification('error', 'Error updating Mission CC');
        }
      } catch (error) {
        console.error(error);
        displayNotification('error', 'An error occurred while updating Mission CC');
      }
    }
  };

  const deleteMissionCC = async (updatedActor) => {
    if (!updatedActor.user_id) {
      displayNotification("warning", " Letter CC is not assigned.");
    }else{
      try {
        const response = await sendAPIRequest(
          `/api/pvsa/mission-correspondence-cc/assign-letter-cc/${updatedActor.id}`,
          "PUT",
          {
            mission_id: updatedActor.mission_id,
            is_letter_cc: false, // Send the updated value
          }
        );

        const result = await response.json();
        if (result && result.success) {
          // Update local state upon successful backend update
          const updatedCCTableData = CCDataTable.map((actor) =>
            actor.id === updatedActor.id
              ? { ...actor, is_letter_cc: false } // Update the specific actor
              : actor // Keep the rest unchanged
          );
          setCCDataTable(updatedCCTableData);

          displayNotification('success', 'Successfully updated Mission CC');
        } else {
          displayNotification('error', 'Error updating Mission CC');
        }
      } catch (error) {
        console.error(error);
        displayNotification('error', 'An error occurred while updating Mission CC');
      }
    }
  };
  return (
    <>
      <div className="header d-flex btn-res1 w-100" style={{ backgroundColor: "#E7E5DA" }}>
        <div className="col-12 bg-beige">
          <div className="card-title1 text-center text-dark">{t("-1", "Mission Actors")}</div>
        </div>
      </div>
      <MissionActorsComponent
        tableData={actorTableData}
        canChangeMissionActors={canChangeMissionActors}
        handleAddClick={handleAddClick}
        handleUpdate={handleUpdate}
        handleDeleteClick={handleDeleteClick}
        correspondenceLoading={correspondenceLoading}
      />
      <MissionCCsComponent
        tableData={CCDataTable}
        canChangeMissionActors={canChangeMissionActors}
        handleAddClick={handleMissionCCAddClick}
        handleUpdate={updateMissionCCState}
        handleDeleteClick={deleteMissionCC}
        correspondenceLoading={correspondenceLoading}
      />
      {/* <CustomCard>
        <Card.Body>
          <table className="table table-bordered">
            <thead className="bg-primary text-white">
              <tr>
                <th width="50" className="text-center">
                  #
                </th>
                <th>Mission Actors</th>
                <th>Users</th>
                <th>Is Letter CC?</th>
                {
                  canChangeMissionActors() && (
                    <th>Action</th>
                  )
                }
              </tr>
            </thead>
            <tbody>
              {
                tableData.map((actor, index) => (
                  <MissionActorsRenderRow
                    actor={actor}
                    index={index}
                    handleAddAll={handleAddAll}
                    handleAddClick={handleAddClick}
                    handleUpdate={handleUpdate}
                    handleDeleteClick={handleDeleteClick}
                    canChangeMissionActors={canChangeMissionActors}
                  />
                ))
              }
            </tbody>
          </table>
        </Card.Body>
      </CustomCard>
      {
        canChangeMissionActors() && (
          <div className="d-flex ms-2 m-2">
            <div className="ms-auto">
              <Button
                variant="contained"
                color="success"
                startIcon={correspondenceLoading ? <FaSpinner className="fa-spin" /> : <MdCheck />}
                onClick={handleSave}
                disabled={correspondenceLoading}
              >
                Save
              </Button>
            </div>
          </div>
        )
      } */}
    </>
  );
};


MissionCC.defaultProps = {
  missionID: "",
  canChangeMissionActors: () => { },
  refresh: false
};

export default MissionCC;
